import { useSelector } from "react-redux";
import type { RootState } from "../store/types";

export const useFeatureFlag = (flagName: string): boolean => {
  const flags = useSelector((state: RootState) => state.featureFlags.flags);
  return flags?.includes(flagName) ?? false;
};
